import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { v4 as uuidv4 } from "uuid";
import { GroupGridViewModel, IGroupGridViewDTO } from "./groupList";
let TeamDetailViewModel = /** @class */ (() => {
    var _a;
    class TeamDetailViewModel {
        constructor() {
            this.teamId = uuidv4();
        }
    }
    __decorate([
        Type(() => GroupGridViewModel),
        __metadata("design:type", typeof (_a = typeof IGroupGridViewDTO !== "undefined" && IGroupGridViewDTO) === "function" ? _a : Object)
    ], TeamDetailViewModel.prototype, "groupItems", void 0);
    return TeamDetailViewModel;
})();
export { TeamDetailViewModel };
export default class viewTeam extends TeamDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
